import { Field, useFormikContext } from 'formik';
import React from 'react';
import { AutoCompleteSelectUI, DateTimePickerUI, FormErrorUI, FormLabelUI, InputUI } from '../../../Interface';
import { IconButton, Stack, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';

const TodoDialogFields = ({ toggleField, visibleFields, autoCompleteOptions }) => {
  const { errors, validateField, setFieldValue, values } = useFormikContext();

  const simpleTaskRespPersonListVal = autoCompleteOptions.user.filter((option) =>
    values.simpleTaskRespPersonlist.some((person) => person.userId === option.value)
  );

  const updateDuration = (startDate, endDate) => {
    const duration = dayjs(endDate).diff(dayjs(startDate), 'hour', true);

    setFieldValue('duration', duration);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Field
          type="text"
          name="simpleTaskName"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Mikor, kivel, mit és MIÉRT kell tenned legközelebb? Írd ide a feladat célját!" />}
          helperText={<FormErrorUI message={errors.simpleTaskName} />}
          InputLabelProps={{ shrink: values.simpleTaskName !== '' }}
          inputProps={{
            maxLength: 300,
          }}
          multiline
          rows={4}
        />
      </Grid>
      <Grid item xs={6}>
        <Field
          type="autocomplete"
          name="resposiblePersonId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Felelős" />}
          size="small"
          variant="outlined"
          helperText={<FormErrorUI message={errors.resposiblePersonId} />}
          onChange={(_e, newVal) => {
            setFieldValue('resposiblePersonId', newVal?.value ?? null).then(() => {
              validateField('resposiblePersonId');
            });
          }}
          InputLabelProps={{ shrink: values.resposiblePersonId !== '' }}
          selectedValue={values.resposiblePersonId}
          dataset={autoCompleteOptions.user}
        />
      </Grid>

      <Grid item xs={6}>
        <Field
          type="autocomplete"
          name="simpleTaskTypeId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Feladat típusa" />}
          variant="outlined"
          size="small"
          helperText={<FormErrorUI message={errors.simpleTaskTypeId} />}
          onChange={(_e, newVal) => {
            setFieldValue('simpleTaskTypeId', newVal?.value ?? null).then(() => {
              validateField('simpleTaskTypeId');
            });
          }}
          InputLabelProps={{ shrink: values.simpleTaskTypeId !== '' }}
          selectedValue={values.simpleTaskTypeId}
          dataset={autoCompleteOptions?.taskType}
        />
      </Grid>

      <Grid item xs={6}>
        <Field
          type="date"
          name="startDate"
          component={DateTimePickerUI}
          value={values.startDate}
          fullWidth
          label={<FormLabelUI text="Kezdő dátum" />}
          variant="outlined"
          size="small"
          helperText={<FormErrorUI message={errors.startDate} />}
          onChange={(date) => {
            setFieldValue('startDate', date).then(() => {
              validateField('startDate');
            });

            updateDuration(date, values.endDate);
          }}
          InputLabelProps={{ shrink: values.startDate !== '' }}
        />
      </Grid>

      <Grid item xs={6}>
        <Field
          type="date"
          name="endDate"
          component={DateTimePickerUI}
          value={values.endDate}
          fullWidth
          label={<FormLabelUI text="Határidő" />}
          variant="outlined"
          size="small"
          helperText={<FormErrorUI message={errors.endDate} />}
          onChange={(date) => {
            setFieldValue('endDate', date).then(() => {
              validateField('endDate');
            });

            updateDuration(values.startDate, date);
          }}
          InputLabelProps={{ shrink: values.endDate !== '' }}
        />
      </Grid>

      {visibleFields.simpleTaskRespPersonlist && (
        <Grid item xs={12}>
          <Stack direction="row" alignItems="center">
            <Field
              type="autocomplete"
              name="simpleTaskRespPersonlist"
              component={AutoCompleteSelectUI}
              fullWidth
              label={<FormLabelUI text="Érintettek" />}
              variant="outlined"
              size="small"
              helperText={<FormErrorUI message={errors.simpleTaskRespPersonlist} />}
              onChange={(_e, newVal) => {
                const mappedValues = newVal.map((item) => ({
                  userId: item.value,
                  roleName: 'Érintett',
                }));

                setFieldValue('simpleTaskRespPersonlist', mappedValues).then(() => {
                  validateField('simpleTaskRespPersonlist');
                });
              }}
              InputLabelProps={{ shrink: values.simpleTaskRespPersonlist !== '' }}
              selectedValue={simpleTaskRespPersonListVal}
              dataset={autoCompleteOptions?.user}
              isOptionEqualToValue={(option, value) => option.value === value.value}
              multiple
              freeSolo
            />
            <IconButton
              onClick={() => toggleField('simpleTaskRespPersonlist', values)}
              sx={{ color: '#9ca3af', mt: -0.5 }}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
        </Grid>
      )}
    </Grid>
  );
};

export default TodoDialogFields;
